import type { IContactVerificationScoreItemIdSmartOverview } from './ContactVerificationScoreItemIdSmartOverview.interface';

export default class ContactVerificationScoreItemIdSmartOverview
  implements IContactVerificationScoreItemIdSmartOverview {
  documents: string;
  faceMatch: string;
  liveness: string;
  overall: string;
  status: string;
  verificationCompleted: string;
  verificationInitiated: string;

  static build = (data: IContactVerificationScoreItemIdSmartOverview) =>
    new ContactVerificationScoreItemIdSmartOverview(data);

  static blank = () => new ContactVerificationScoreItemIdSmartOverview();

  /**
   * Constructor
   * @param {IContactVerificationScoreItemIdSmartOverview} data
   */
  constructor(data?: IContactVerificationScoreItemIdSmartOverview) {
    this.documents = data?.documents || '';
    this.faceMatch = data?.faceMatch || '';
    this.liveness = data?.liveness || '';
    this.overall = data?.overall || '';
    this.status = data?.status || '';
    this.verificationCompleted = data?.verificationCompleted || '';
    this.verificationInitiated = data?.verificationInitiated || '';
  }
}
